/**
 * Hook: useForm
 *
 * Generic form state management with change tracking and reset
 *
 * @param {Object} options - Form configuration
 * @param {Object} options.initialValues - Initial form values
 * @param {Function} options.onFieldChange - Optional callback when fields change
 * @returns {Object} { values, setValues, setField, reset, isDirty }
 */

import { useCallback, useState } from 'react'

export const useForm = ({ initialValues, onFieldChange }) => {
  const [values, setValues] = useState(initialValues)
  const [initialState] = useState(initialValues)

  const setField = useCallback((field, value) => {
    setValues((current) => {
      const next = { ...current, [field]: value }
      if (onFieldChange) {
        onFieldChange(next)
      }
      return next
    })
  }, [onFieldChange])

  const reset = useCallback(() => {
    setValues(initialState)
  }, [initialState])

  const isDirty = JSON.stringify(values) !== JSON.stringify(initialState)

  return {
    values,
    setValues,
    setField,
    reset,
    isDirty
  }
}